<template>
    <div class="wrapper">
        <label v-if="label">{{ label }} :</label>
        <div class="input-container">
            <vue-autosuggest
                :value="value"
                :suggestions="suggestions"
                :input-props="inputProps"
                @input="onInput"
                @selected="onSelect"
                @closed="onClose"
            >
                <template slot-scope="{suggestion}">
                    <slot :option="suggestion.item">
                        {{ suggestion.item.name }}
                    </slot>
                </template>
            </vue-autosuggest>
            <Spinner v-if="loading" :color="spinnerColor" class="spinner"/>
        </div>
    </div>
</template>
<script>
import { VueAutosuggest } from 'vue-autosuggest';

import { Spinner } from './index';

export default {
    name: 'Autosuggest',
    components: { VueAutosuggest, Spinner },
    props: {
        value: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => ([]),
        },
        label: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        updateOnSelect: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        spinnerColor: {
            type: String,
            default: '',
        },
    },
    computed: {
        inputProps () {
            return {
                autocomplete: Math.random().toString(),
                disabled: this.disabled,
                placeholder: this.placeholder,
                style: {
                    paddingRight: this.loading ? '44px' : '16px',
                },
            };
        },
        suggestions () {
            return [{ data: this.options }];
        },
    },
    methods: {
        onInput (value) {
            if (this.updateOnSelect) {
                this.$emit('type', value);
            } else {
                this.$emit('input', value);
            }
        },
        onSelect (option) {
            if (!this.disabled && option) {
                this.$emit('select', option.item);
            }
        },
        onClose () {
            if (this.updateOnSelect) {
                this.$emit('close');
            }
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/colors';
.wrapper {
  > label {
    display: block;
    padding: 8px 0;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: $black;
    user-select: none;
  }

  .input-container {
    position: relative;

    input {
      width: 100%;
      padding: 16px;
      outline: none;
      border: 1px solid $grey-lightest;
      border-radius: 4px;
      background-color: $white-darkest;
      font-family: inherit;
      font-size: 14px;
      caret-color: var(--COLOR_PRIMARY);
      transition: all .1s ease-in-out;

      &.autosuggest__input--open {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:focus {
        border-color: var(--COLOR_PRIMARY);
        color: $black;
      }

      &:disabled {
        pointer-events: none;
      }

      &::placeholder {
        color: $grey-light;
      }
    }

    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 1000;
      width: 100%;
      color: $black;
      border: 1px solid $grey-lightest;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: $white;
      max-height: 250px;
      overflow-y: auto;

      &-container {
        position: relative;
        width: 100%;
      }

      ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
      }

      .autosuggest__results-item {
        cursor: pointer;
        padding: 8px 16px;

        &:has(.option-loading) {
          &:active,
          &:hover,
          &:focus,
          &--highlighted {
            background: $red;
          }
        }

        &:active,
        &:hover,
        &:focus,
        &--highlighted {
          background: $white-darkest;
          color: var(--COLOR_PRIMARY);
        }
      }
    }

    .spinner {
      position: absolute;
      right: 20px;
      bottom: calc(50% - 7px);
      width: 14px;
      height: 14px;
    }
  }
}
</style>
